import React from "react";
import SecondaryHeader from "../../components/common/SecondaryHeader";
import { FaCalendarAlt, FaUser, FaArrowRight } from "react-icons/fa";

const Blogs = () => {
  const blogPosts = [
    {
      id: 3,
      title: "Real Estate Investment Strategies for 2024",
      excerpt:
        "Learn about the most promising real estate investment opportunities in the current market landscape.",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      author: "Emily Rodriguez",
      date: "Dec 10, 2024",
    },
    {
      id: 4,
      title: "Maximizing Small Spaces: Interior Design Secrets",
      excerpt:
        "Transform compact living areas into functional and beautiful spaces with these design principles.",
      image:
        "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      author: "David Kim",
      date: "Dec 8, 2024",
    },
    {
      id: 5,
      title: "Market Trends: What to Expect in 2024",
      excerpt:
        "Analysis of upcoming real estate market trends and predictions for the coming year.",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      author: "Lisa Wang",
      date: "Dec 5, 2024",
    },
    {
      id: 6,
      title: "Sustainable Living: Eco-Friendly Home Features",
      excerpt:
        "Explore the latest eco-friendly home features that save money and help the environment.",
      image:
        "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      author: "Alex Thompson",
      date: "Dec 3, 2024",
    },
    {
      id: 7,
      title: "Understanding Mortgage Rates in Today's Market",
      excerpt:
        "A comprehensive guide to navigating mortgage rates and finding the best deals for your home purchase.",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      author: "Robert Martinez",
      date: "Nov 28, 2024",
    },
    {
      id: 8,
      title: "The Art of Home Staging: Sell Faster, Sell Higher",
      excerpt:
        "Learn professional home staging techniques that can significantly increase your property's value and appeal.",
      image:
        "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      author: "Jennifer Lee",
      date: "Nov 25, 2024",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <SecondaryHeader
        pageHeading="Our Blog"
        breadcomb={<span>Home / Blogs</span>}
        minHeight="250px"
      />

      {/* Blog Posts Section */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Blog Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group"
              >
                {/* Blog Image */}
                <div className="relative overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>

                {/* Blog Content */}
                <div className="p-6">
                  {/* Meta Information */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                      <FaCalendarAlt className="text-gray-400" />
                      <span>{post.date}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                      <FaUser className="text-gray-400" />
                      <span>{post.author}</span>
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-[#E4E95B] transition-colors duration-200 line-clamp-2">
                    {post.title}
                  </h3>

                  {/* Excerpt */}
                  <p className="text-gray-600 mb-6 leading-relaxed line-clamp-3">
                    {post.excerpt}
                  </p>

                  {/* Read More Button */}
                  <button className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-all duration-300 transform hover:scale-105 font-semibold flex items-center justify-center gap-2 group/btn">
                    Read Article
                    <FaArrowRight className="group-hover/btn:translate-x-1 transition-transform duration-200" />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blogs;
